module.exports = __webpack_public_path__ + "static/media/zhutong.logo-l.fa37e432.png";